import { format } from 'date-fns'
import koLocale from 'date-fns/locale/ko'
import { makeObservable, observable } from 'mobx'

import { EMPTY_NUMBER_ID } from '@/constant/common'
import { Student } from '..'
import { DTO } from '../DTO'

// 3 Depth - 출결
export class Attendance extends DTO {
  id = EMPTY_NUMBER_ID
  studentId: Student['id']
  status: res.Attendance['status']
  enterDatetime: Date
  quitDatetime?: Date | null

  constructor({ id, studentId, status, enterDatetime, quitDatetime }: res.Attendance) {
    super()
    makeObservable(this, {
      status: observable,
      enterDatetime: observable,
      quitDatetime: observable,
    })
    this.id = id
    this.studentId = studentId
    this.status = status
    this.enterDatetime = new Date(enterDatetime)
    if (quitDatetime) this.quitDatetime = new Date(quitDatetime)
  }

  get enterToKorTimeString() {
    return this.enterDatetime && Attendance.dateToKorTimeString(this.enterDatetime)
  }

  get quitToKorTimeString() {
    return this.quitDatetime && Attendance.dateToKorTimeString(this.quitDatetime)
  }

  get lastStateDate() {
    if (this.status === 'QUIT') return this.quitDatetime
    if (this.status === 'ENTER') return this.enterDatetime
  }

  // ex) 오후 07:13
  private static dateToKorTimeString(date: Date) {
    return format(date, 'a hh:mm', { locale: koLocale })
  }
}
